import { makeStyles, tokens, shorthands, MenuItem } from '@fluentui/react-components';
import { ReactNode } from 'react';

import { TIcon } from '@shared/types';

const useStyles = makeStyles({
  default: {
    // ...shorthands.borderColor('transparent'),
  },
  active: {
    ...shorthands.border('1px'),
    ...shorthands.borderColor(tokens.colorNeutralStrokeAccessible),
  },
});

type Props = {
  children: ReactNode;
  icon?: TIcon;
  isActive?: boolean;
  disabled?: boolean;
  onClick: () => unknown;
};

const ToolbarMenuItem = ({ children, isActive = false, icon = undefined, disabled = false, onClick }: Props) => {
  const classes = useStyles();

  return (
    <MenuItem icon={icon} disabled={disabled} onClick={onClick} className={isActive ? classes.active : classes.default}>
      {children}
    </MenuItem>
  );
};

export default ToolbarMenuItem;
